import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AuthModal } from "@/components/auth/AuthModal";
import { Button } from "@/components/ui/button";
import { UserCircle } from "lucide-react";

export const UserMenuButton = () => {
  const { user, isLoading } = useAuth();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  if (isLoading) {
    return (
      <div className="h-9 w-9 rounded-full bg-muted animate-pulse" />
    );
  }

  if (user) {
    return (
      <Link to="/dashboard">
        <Button
          variant="ghost"
          size="icon"
          className="h-9 w-9 rounded-full bg-primary/10 hover:bg-primary/20 transition-colors"
          title="החשבון שלי"
        >
          <UserCircle className="h-5 w-5 text-primary" />
        </Button>
      </Link>
    );
  }

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="h-9 w-9 rounded-full hover:bg-primary/10 transition-colors"
        onClick={() => setIsAuthModalOpen(true)}
        title="התחבר"
      >
        <UserCircle className="h-5 w-5 text-muted-foreground" />
      </Button>
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </>
  );
};
